module.exports = __webpack_public_path__ + "img/9788994506326.c97db6f3.jpg";